
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Uri durant la troisième vague`}</h2>
    <p>{`La situation dans le canton de Suisse centrale est fragile. Le lundi 12 avril 2021, lors d'une conférence de presse, le gouvernement cantonal déclare que les chiffres des infections sont «alarmants». En fait, presque toutes les communes d'Uri affichent actuellement une incidence des nouveaux cas supérieure à la moyenne. Le Canton réagit: les tests se multiplient dans les écoles, à l'hôpital cantonal les opérations planifiées sont reportées, et la station de ski d'Andermatt boucle prématurément sa saison sur ordre du gouvernement.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;